import { combineReducers } from '@rxsv/core';

import * as FiltersSettings from './filters-settings';
import * as EmailSupport from './email-support';
import * as View from './view';
import * as Auth from './auth';
import * as Init from './init';
import * as TA from './triggersAndActions';
import * as Performance from './performance';

export const reducer = combineReducers({
    filtersSettings: FiltersSettings.reducer,
    emailSupport: EmailSupport.reducer,
    view: View.reducer,
    portlet: Init.reducer,
    auth: Auth.reducer,
    triggersAndActions: TA.reducer,
    performance: Performance.reducer,
});

export type AppState = ReturnType<typeof reducer>;
